import { FormGroup } from '@angular/forms'
import { CanDeactivate } from '@angular/router'

export class FormCanDeactivate implements CanDeactivate<any> {
	static forms = new Set<FormGroup>()

	constructor() {
		console.log('FormCanDeactivate constructor')
	}

	static canDeactivate(): boolean {
		for (const form of this.forms) {
			if (form.dirty) {
				return confirm(
					'You have unsaved changes. Are you sure you want to leave?',
				)
			}
		}
		return true
	}

	canDeactivate(): boolean {
		return FormCanDeactivate.canDeactivate()
	}

	static registerForm(form: FormGroup) {
		FormCanDeactivate.forms.add(form)
	}

	static unregisterForm(form: FormGroup) {
		FormCanDeactivate.forms.delete(form)
	}

	static unregisterAllForms() {
		FormCanDeactivate.forms.clear()
	}
}

addEventListener('beforeunload', (event) => {
	if (!FormCanDeactivate.canDeactivate()) {
		event.preventDefault()
	}
})
